<template>

  <b-row v-if="esTrauma">
    <b-col>
      <b-card
       
        no-body
        :class="{ 'open': visibleBody }"
      >

        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA TRAUMATOLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">
            <b-row>
              <b-col>

                <b-form-group class="my-2">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Ha experimentado alguno de los siguientes síntomas? (Seleccione todos los que apliquen)
                  </label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="sintomasOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => traumatologia.sintomas = onAddNewOpt(newArray)"
                  />

                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleTraumaComienzo">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">¿Cuándo comenzaron sus síntomas?</label>
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="comienzoOpts"
                    :reduce="option => option"
                    label="text"
                    v-model="traumatologia.comienzo"
                  />
                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleTraumaFactores">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Factores de riesgo?
                  </label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="factoresOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => traumatologia.factores = onAddNewOpt(newArray)"
                  />
                  
                </b-form-group>
                
                <b-form-group class="my-2" v-if="isVisibleTraumaTratamientos">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Recibe actualmente algun tipo de tratamiento? (Seleccione todos los que apliquen)
                  </label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="tratamienosOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => traumatologia.tratamientos = onAddNewOpt(newArray)"
                  />
                  
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import vSelect       from "vue-select";
import { addNewOpt } from '@/shared/helpers';
import { mapState } from "vuex";

export default {
  name: "SemiologiaTraumatologica",

  components: {
    vSelect
  },

  data() {
    return {
      visibleBody: true,
      traumatologia:{
        sintomas:[],
        comienzo:null,
        factores:[],
        tratamientos:[],
      },

      isVisibleTraumaComienzo:false,
      isVisibleTraumaFactores:false,
      isVisibleTraumaTratamientos:false,

      sintomasOpts : [
        { value: 'dolor_persistente',        text: 'Dolor persistente en articulaciones' },
        { value: 'hinchazon',                text: 'Hinchazón en las articulaciones' },
        { value: 'rigidez_matutina',         text: 'Rigidez matutina' },
        { value: 'debilidad_muscular',       text: 'Debilidad muscular' },
        { value: 'perdidaMovilidad',         text: 'Pérdida de movilidad' },
        { value: 'crepito',                  text: 'Crépito (sonido de crujido en las articulaciones)' },
        { value: 'dolor_espalda',            text: 'Dolor de espalda' },
        { value: 'dolor_cuello',             text: 'Dolor en cuello' },
        { value: 'deformidades_articulares', text: 'Deformidades articulares' },
        { value: 'fracturas_recurrentes',    text: 'Fracturas recurrentes' }
      ],

      comienzoOpts:[
        { value: 'dias',    text: 'días' },
        { value: 'semanas', text: 'semanas' },
        { value: 'meses',   text: 'meses' },
        { value: 'anios',   text: 'años' }
      ],

      factoresOpts : [
        { 
          value: 'antecedentes_familiares', 
          text: 'Antecedentes familiares de enfermedades musculoesqueléticas' 
        },
        { 
          value: 'lesiones_deportivas_previas', 
          text: 'Lesiones deportivas previas' 
        },
        { 
          value: 'osteoporosis', 
          text: 'Osteoporosis' 
        },
        { 
          value: 'trabajo_fisico_intenso', 
          text: 'Trabajo físico intenso' 
        },
        { 
          value: 'sedentarismo', 
          text: 'Sedentarismo' 
        },
        { 
          value: 'uso_prolongado_corticosteroides', 
          text: 'Uso prolongado de corticosteroides' 
        },
        { 
          value: 'artritis', 
          text: 'Artritis' 
        }
      ],

      tratamienosOpts: [
        { value: 'medicamentos_antiinflamatorios', text: 'Medicamentos antiinflamatorios' },
        { value: 'fisioterapia',                   text: 'Fisioterapia' },
        { value: 'inyecciones_corticosteroides',   text: 'Inyecciones de corticosteroides' },
        { value: 'cirugia',                        text: 'Cirugía' },
        { value: 'terapia_calor_frio',             text: 'Terapia de calor/frío' },
        { value: 'aparatos_ortopedicos',           text: 'Uso de aparatos ortopédicos' },
        { value: 'rehabilitacion',                 text: 'Rehabilitación' }
      ]

    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },
  computed:{
    ...mapState({
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esTrauma(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000137';
    },

  },

  watch: {
    traumatologia: {
      handler(newValue) {
        this.isVisibleTraumaComienzo     = newValue.sintomas.length > 0;
        this.isVisibleTraumaFactores     = newValue.comienzo && this.isVisibleTraumaComienzo;
        this.isVisibleTraumaTratamientos = newValue.factores.length > 0 && this.isVisibleTraumaFactores;
      },
      deep: true
    }
  },

}
</script>

<style>
  .checkbox-sintomas .custom-check {
    width: 100%;
  }

  .otros-check .custom-control-label{
    display: flex;
    width: 100%;
  } 
</style>